import React from 'react';
import { IconButton, Paper, Slide, Tooltip } from "@material-ui/core";
import CloseRoundedIcon from "@material-ui/icons/CloseRounded";
import MeditocBody from "./MeditocBody";
import MeditocFooter from "../layout/MeditocFooter";

import Dialog from "@material-ui/core/Dialog";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function MeditocModalFull(props) {
    const { open, setopen, children, title, actions } = props;

    const mtButtons = actions === undefined ? null : actions;

    const handleClose = () => {
        setopen(false);
    };

    return (
        <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
            <div className="flx-grw-1 pos-rel">
                <div>
                    <Paper elevation={3}>
                        <div className="bar-main">
                            <div className="ops-nor bold size-20 align-self-center flx-grw-1">{title}</div>
                            <div>
                                {mtButtons}
                                <Tooltip title="Cerrar ventana" arrow>
                                    <IconButton onClick={handleClose}>
                                        <CloseRoundedIcon className="color-0" />
                                    </IconButton>
                                </Tooltip>
                            </div>
                        </div>
                    </Paper>
                    <MeditocBody>{children}</MeditocBody>
                </div>
                <div style={{ height: 30 }}></div>
            </div>
            <MeditocFooter />
        </Dialog>
    );
}
